import App from "../../services/App/App.js";
import AppModule from "../../services/App/AppModule.js";
import AppModuleAttr from "../../services/App/AppModuleAttr.js";
import AppModuleType from "../../services/App/AppModuleType.js";
import RouterModel from "../../router/RouterModel.js";

import SpD from "./Details/SpD.vue";
import SpE from "./Edit/SpE.vue";
import SpL from "../SpecialPrice/List/SpL.vue";
import SpN from "./New/SpN.vue";

export default {
  Path: {
    List: RouterModel.getPath(AppModule.SpecialPrice, AppModuleType.List),
    New: RouterModel.getPath(AppModule.SpecialPrice, AppModuleType.New),
    Edit: RouterModel.getPath(AppModule.SpecialPrice, AppModuleType.Edit),
    Details: RouterModel.getPath(AppModule.SpecialPrice, AppModuleType.Details),
  },

  getRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.SpecialPrice, AppModuleType.Details),
        name: RouterModel.getName(AppModule.SpecialPrice, AppModuleType.Details),
        component: SpD,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.SpecialPrice, AppModuleType.Details),
          module: RouterModel.getModule(AppModule.SpecialPrice),
          moduleattr: AppModuleAttr.SpecialPrice_Act_Details,
          moduletype: AppModuleType.Details
        }
      },
      {
        path: RouterModel.getPath(AppModule.SpecialPrice, AppModuleType.List),
        name: RouterModel.getName(AppModule.SpecialPrice, AppModuleType.List),
        component: SpL,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.SpecialPrice, AppModuleType.List),
          module: RouterModel.getModule(AppModule.SpecialPrice),
          moduleattr: AppModuleAttr.SpecialPrice_Act_List,
          moduletype: AppModuleType.List,
          new: {
            module: RouterModel.getModule(AppModule.SpecialPrice),
            moduleattr: AppModuleAttr.SpecialPrice_Act_New,
            moduletype: AppModuleType.New, 
          }
        }
      },
      {
        path: RouterModel.getPath(AppModule.SpecialPrice, AppModuleType.New),
        name: RouterModel.getName(AppModule.SpecialPrice, AppModuleType.New),
        component: SpN,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.SpecialPrice, AppModuleType.New),
          module: RouterModel.getModule(AppModule.SpecialPrice),
          moduleattr: AppModuleAttr.SpecialPrice_Act_New,
          moduletype: AppModuleType.New,
          cancel: {
            url: RouterModel.getPath(AppModule.SpecialPrice, AppModuleType.List)
          },
          submit: {
            url: RouterModel.getPath(AppModule.SpecialPrice, AppModuleType.Details),
            params: {
              [App.Enum.Param.ID]: [App.Enum.Response.ID]
            }
          }
        }
      },
      {
        path: RouterModel.getPath(AppModule.SpecialPrice, AppModuleType.Edit),
        name: RouterModel.getName(AppModule.SpecialPrice, AppModuleType.Edit),
        component: SpE,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.SpecialPrice, AppModuleType.Edit),
          module: RouterModel.getModule(AppModule.SpecialPrice),
          moduleattr: AppModuleAttr.SpecialPrice_Act_Edit,
          moduletype: AppModuleType.Edit,
          cancel: {
            url: RouterModel.getPath(AppModule.SpecialPrice, AppModuleType.List)
          },
          submit: {
            url: RouterModel.getPath(AppModule.SpecialPrice, AppModuleType.Details),
            params: {
              [App.Enum.Param.ID]: [App.Enum.Response.ID]
            }
          }
        }
      }
    ];
  },

  getRootRoutes() {
    return [];
  }
}